module.exports = __webpack_public_path__ + "img/family-old.71fa7efc.svg";